/* unplugin-vue-components disabled */import { render } from "./dsroutelist.vue?vue&type=template&id=8d2ddefc&scoped=true"
import script from "./dsroutelist.vue?vue&type=script&lang=js"
export * from "./dsroutelist.vue?vue&type=script&lang=js"

import "./dsroutelist.vue?vue&type=style&index=0&id=8d2ddefc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2ddefc"]])

export default __exports__